/* ==========================================================================
   HAPŪ HELPERS — SA CONSULT QUESTIONNAIRE
   --------------------------------------------------------------------------
   Compiles every questionnaire answer into a clean plain-text contact[body]
   right before the native Shopify contact form submits. contact[name] and
   contact[email] are real fields with HTML5 required validation, so the
   submit event only fires once those are valid — we then populate the body
   and let the submission continue.
   ========================================================================== */

(function () {
  'use strict';

  function init() {
    var form = document.getElementById('consult-sa-form');
    if (!form) return;

    var bodyInput = document.getElementById('consult-sa-body');
    if (!bodyInput) return;

    function buildBody() {
      var lines = [];
      lines.push('TTC CONSULTATION QUESTIONNAIRE');
      lines.push('==============================');
      lines.push('');

      form.querySelectorAll('[data-consult-field]').forEach(function (field) {
        var label = field.getAttribute('data-label') || '';
        var value = '';

        var radio = field.querySelector('input[type="radio"]:checked');
        if (radio) {
          value = radio.value;
        } else {
          var textish = field.querySelector('input[type="text"], input[type="email"], input[type="tel"], textarea');
          if (textish) {
            value = (textish.value || '').trim();
            if (value && field.hasAttribute('data-phone')) {
              value = '+27 ' + value;
            }
          }
        }

        if (value === '') value = '—';

        lines.push(label + ': ' + value);
      });

      lines.push('');
      lines.push('—');
      lines.push('Submitted from ' + window.location.href);
      lines.push('Sent: ' + new Date().toISOString());

      return lines.join('\n');
    }

    /* The submit event fires only after native required-field validation
       passes, so name + email are guaranteed present here. Populate the
       hidden body synchronously and let the form submit normally. */
    form.addEventListener('submit', function () {
      bodyInput.value = buildBody();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
